
import Vue from "vue";
import HomePageSection3 from "./Home_Sections/Section3.vue";
const HomePageSection1 = () => import("./Home_Sections/Section1.vue");
const HomePageSection2 = () => import("./Home_Sections/Section2.vue");
// const HomePageSection3 = () => import("./Home_Sections/Section3.vue");
const HomePageSection4 = () => import("./Home_Sections/Section4.vue");
const Form = () => import("./Form.vue");
const Loader = () => import("@/components/Loader.vue");
const Modal = () => import("./OpenDay/Modals/modalOpenDay.vue")
const ModalIntriga = () => import("./CentroIdiomaIntriga/Modals/modalCentroIdiomaIntriga.vue")
const ModalCookies = () => import("./Home_Sections/Modals/ModalCookies.vue")
export default Vue.extend({
  name: "HomePage",

  components: {
    ModalCookies,
    Modal,
    ModalIntriga,
    HomePageSection1,
    HomePageSection2,
    HomePageSection3,
    HomePageSection4,
    Form,
    Loader,
  },
  data: () => ({}),
});
